<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Alterar Status"
    type-modal="mark_as_sent_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="send()">

        <d-form-row>
          <!-- Message -->
          <d-col md="12">
            <p>Deseja marcar esse orçamento como enviado para o cliente?</p>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="send(false)"
        class="btn btn-sm btn-secondary mr-4"
      >Não</d-button>
      <d-button
        type="button"
        @click="send(true)"
        class="btn btn-sm btn-primary"
      >Sim</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';

export default {
  name: 'mark-as-sent-modal',
  props: {
    quotationId: {
      type: Number,
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    ModalTemplate,
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getSettings',
    ]),
    send(markAsSent) {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.updateStatus(this.quotationId, this.status, markAsSent)
        .then(() => {
          this.setToggle({ type: 'mark_as_sent_modal', bool: false });
          this.activeAlert({ message: 'Status do orçamento alterado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
</script>
<style lang="scss">
@media (min-width: 992px) {
  .modal-sm {
      max-width: 550px;
  }
}
</style>
<style lang="scss" scoped>
  .modal-sm {
    p {
      margin-bottom: 0;
    }
  }
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
